import api from "../../../services/api";

const BASE = "/v1/rentals";

const searchAssets = (params) =>
  api.get(`${BASE}/assets`, { params }).then((r) => r.data);
const getAsset = (id) => api.get(`${BASE}/assets/${id}`).then((r) => r.data);
const reserveAsset = (payload) =>
  api.post(`${BASE}/reservations`, payload).then((r) => r.data);
const getReservation = (id) =>
  api.get(`${BASE}/reservations/${id}`).then((r) => r.data);
const checkoutReservation = (id, payload) =>
  api
    .post(`${BASE}/checkout`, { reservationId: id, ...payload })
    .then((r) => r.data);
const getBookings = (params) =>
  api.get(`${BASE}/bookings`, { params }).then((r) => r.data);
const getSubscriptions = (params) =>
  api.get(`${BASE}/subscriptions`, { params }).then((r) => r.data);

export default {
  searchAssets,
  getAsset,
  reserveAsset,
  getReservation,
  checkoutReservation,
  getBookings,
  getSubscriptions,
};
